export const SET_UPDATE_MODEL = "SET_UPDATE_MODEL";
export const SET_NEW_MODEL = "SET_NEW_MODEL";
export const SET_RESET_MODEL = "SET_RESET_MODEL";
export const SET_LOADING_NOTA = "SET_LOADING_NOTA";
export const SET_LOADING_RESERVATION = "SET_LOADING_RESERVATION";
export const SET_UPDATE_MODEL_ARRAY = "SET_UPDATE_MODEL_ARRAY";
export const SET_NOTA = "SET_NOTA";
export const DEL_TRANSPORT_SERVICE = "DEL_TRANSPORT_SERVICE";
export const ADD_TRANSPORT_SERVICE = "ADD_TRANSPORT_SERVICE";
export const ADD_TRANSPORT_SERVICE_CLONE = "ADD_TRANSPORT_SERVICE_CLONE";
export const SET_TRANSPORT_SERVICE = "SET_TRANSPORT_SERVICE";
export const SET_UPDATE_TRANSPORT_SERVICE = "SET_UPDATE_TRANSPORT_SERVICE";
export const SET_UPDATE_QUOTE_PROPS = "SET_UPDATE_QUOTE_PROPS"
export const SET_LOADING_REVIEWS = "SET_LOADING_REVIEWS"
export const SET_REVIEWS = "SET_REVIEWS"


export const initialState = () => ({
	id: -1,
	token: null,
	clientFirstName: "",
	clientLastName: "",
	clientPhone: "",
	clientEmail: "",
	clientLang: "",
	clientBillingInfo:{
		addressLine1: "",
		addressLine2: "",
		city: "",
		companyName: "",
		country: "",
		postalCode: "",
		rfc: "",
	},
	adults: 1,
	children: 0,
	infants: 0,
	creationUser: null,
	clientEdited: false,
	clientConfirmed: false,
	transportServices: [
		{
			id: -1,
			serviceNumber: "",
			contactStatus: "noContacted",
			status: "active",
			pickupPlaceId: undefined,
			dropoffPlaceId: undefined,
			pickup: { name: "", isAirport: false },
			dropoff: { name: "", isAirport: false },
			pickupDatetime: "",
			flightNumber: "",
			flightDatetime: "",
			clientNote: "",
			serviceTypeId: -1,
			supplierServiceTypeId: -1,
			salesChannelId: -1,
			salesChannel: { id: -1, text: "" },
			supplierId: 1,
			supplier: { id: 1, text: "" },
			creationUser: null,
			supplierReference: "",
			supplierNotes: "",
			supplierConfirmation: "pending",
			salesChannelReference: "",
			flightValidationStatus: "none",
			flightValidationData: {},
			fromQuote:false,
			quote:{//es para enviar al back, este indice no lo devuelve el fetch
				specialRate:false,
				specialRateData:{amount:0,reason:''},
				bookingPriceTotal:0,//precio con desc si aplica
				bookingPriceTotalOriginal:0,//precio original del rate
				bookingCurrency:"",
			},
			ratePlanInfo: null,
			bookingPriceTotal:0,
			bookingCurrency:"",
			pointOfSaleId:{value: -1, text: ""},
			paymentStatus:'pending',
			creationDatetime:'',
			trackingStatus:'pending',
			tags:[]
		}
	],
	additionalServices:[],
	travelersPortalUrl: "#",
	bookingPriceTotal: 0,
	netPriceTotal: 0,
	supplierPriceTotal: 0,
	bookingCurrency: "",
	notes: [],
	vouchers: [],
	status: "active",
	client:[]
});
